import { makeStyles, shorthands } from '@fluentui/react-components';

export const useEditVideoPageStyles = makeStyles({
  editVideoPage: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('10px'),
  },
  editVideoContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    '& .video-editor-with-add-image-wrapper': {
      height: '100%',
    },
  },
  spinnerContent: {
    textAlign: 'center',
  },
});
